import React from 'react';
import { Choice, ChoiceItem } from '@ingka/choice';
import urlIcon from '@ingka/ssr-icon/paths/link';
import freeTextIcon from '@ingka/ssr-icon/paths/text-align-left';
import { useTranslation } from 'react-i18next';

interface QrTypeFormProps {
  onSelect: (id: string) => void;
  selected: string | null;
}

const QrTypeForm: React.FC<QrTypeFormProps> = ({ onSelect, selected }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full ">
      <p className="leading-normal font-bold">{t('label.qrType')}</p>
      <div className="demo-choice-container">
        <Choice
          className="demo-choice-flex flex flex-col md:flex-row gap-3 my-6"
          size="medium"
          onSelect={(id) => onSelect(id as string)}
          preselectedIndex={
            selected === 'trackedURL'
              ? 0
              : selected === 'freetext'
              ? 1
              : undefined
          }
        >
          <ChoiceItem
            id="trackedURL"
            imageAlignment="center"
            imagePosition="leading"
            title={t('label.trackedURL')}
            valueAlignment="center"
            ssrIcon={urlIcon}
            className="md:w-[327px]"
          />
          <ChoiceItem
            id="freetext"
            imageAlignment="center"
            imagePosition="leading"
            title={t('label.freetext')}
            valueAlignment="center"
            ssrIcon={freeTextIcon}
            className="md:w-[327px]"
          />
        </Choice>
      </div>
    </div>
  );
};

export default QrTypeForm;
